<div class="hero">
  <app-img-format *ngIf="node?.img?.url" [src]="node.img.url" [alt]="node.title" [aspectRatio]="'21:9'"
    [disableLazyLoad]="true"></app-img-format>
  <ion-text>
    <h1 class="hero-title">{{ node?.title }}</h1>
    <p *ngIf="node?.description" class="hero-description">
      {{ node.description }}
    </p>
    <div class="hero-button">
      <app-button *ngIf="node?.button_text" (click)="buttonLink()" [icon]="{ name: 'arrow-right', position: 'right' }">
        {{ node.button_text }}
      </app-button>
    </div>
  </ion-text>
</div>